import React from 'react'

export const BgSvg = () => {
  return (
    <svg
      width="1384"
      height="690"
      viewBox="0 0 1384 690"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <rect x="0.5" y="0.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="0.5" y="60.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="0.5" y="120.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="0.5" y="480.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="0.5" y="180.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="0.5" y="540.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="0.5" y="240.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="0.5" y="600.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="0.5" y="300.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="0.5" y="660.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="0.5" y="360.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="60.5" y="60.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="60.5" y="120.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="60.5" y="480.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="60.5" y="240.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="60.5" y="600.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="60.5" y="300.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="60.5" y="660.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="60.5" y="360.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="60.5" y="420.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="120.5" y="0.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="120.5" y="60.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="120.5" y="120.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="120.5" y="480.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="120.5" y="180.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="120.5" y="540.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="120.5" y="240.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="120.5" y="600.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="120.5" y="300.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="120.5" y="660.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="120.5" y="420.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="180.5" y="0.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="180.5" y="120.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="180.5" y="480.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="180.5" y="180.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="180.5" y="540.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="180.5" y="300.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="180.5" y="660.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="180.5" y="360.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="180.5" y="420.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="240.5" y="0.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="240.5" y="60.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="240.5" y="120.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="240.5" y="480.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="240.5" y="180.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="240.5" y="540.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="240.5" y="240.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="240.5" y="600.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="240.5" y="300.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="240.5" y="660.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="240.5" y="360.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="240.5" y="420.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="300.5" y="0.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="300.5" y="60.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="300.5" y="120.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="300.5" y="480.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="300.5" y="180.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="300.5" y="540.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="300.5" y="240.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="300.5" y="600.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="300.5" y="360.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="300.5" y="420.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="360.5" y="0.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1080.5" y="0.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="360.5" y="120.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="360.5" y="480.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1080.5" y="120.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1080.5" y="480.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="360.5" y="180.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="360.5" y="540.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1080.5" y="180.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1080.5" y="540.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="360.5" y="240.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="360.5" y="600.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1080.5" y="240.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1080.5" y="600.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="360.5" y="300.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="360.5" y="660.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1080.5" y="300.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1080.5" y="660.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="360.5" y="360.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1080.5" y="360.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="360.5" y="420.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1080.5" y="420.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="420.5" y="0.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1140.5" y="0.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="420.5" y="60.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1140.5" y="60.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="420.5" y="120.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="420.5" y="480.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1140.5" y="120.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1140.5" y="480.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="420.5" y="240.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="420.5" y="600.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1140.5" y="240.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1140.5" y="600.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="420.5" y="300.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="420.5" y="660.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1140.5" y="300.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1140.5" y="660.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="420.5" y="360.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1140.5" y="360.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="480.5" y="0.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1200.5" y="0.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="480.5" y="60.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1200.5" y="60.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="480.5" y="120.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="480.5" y="480.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1200.5" y="120.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1200.5" y="480.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="480.5" y="180.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="480.5" y="540.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1200.5" y="180.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1200.5" y="540.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="480.5" y="240.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="480.5" y="600.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1200.5" y="240.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1200.5" y="600.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="480.5" y="300.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="480.5" y="660.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1200.5" y="300.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1200.5" y="660.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="480.5" y="360.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1200.5" y="360.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="480.5" y="420.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1200.5" y="420.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="540.5" y="60.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1260.5" y="60.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="540.5" y="120.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="540.5" y="480.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1260.5" y="120.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1260.5" y="480.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="540.5" y="180.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="540.5" y="540.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1260.5" y="180.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1260.5" y="540.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="540.5" y="240.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="540.5" y="600.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1260.5" y="240.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1260.5" y="600.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="540.5" y="360.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1260.5" y="360.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="540.5" y="420.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1260.5" y="420.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="600.5" y="0.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1320.5" y="0.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="600.5" y="60.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1320.5" y="60.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="600.5" y="180.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="600.5" y="540.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1320.5" y="180.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1320.5" y="540.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="600.5" y="240.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="600.5" y="600.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1320.5" y="240.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1320.5" y="600.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="600.5" y="300.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="600.5" y="660.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1320.5" y="300.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1320.5" y="660.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="600.5" y="420.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1320.5" y="420.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="660.5" y="0.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1380.5" y="0.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="660.5" y="60.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1380.5" y="60.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="660.5" y="120.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="660.5" y="480.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1380.5" y="120.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1380.5" y="480.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="660.5" y="180.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="660.5" y="540.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1380.5" y="180.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1380.5" y="540.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="660.5" y="300.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="660.5" y="660.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1380.5" y="300.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1380.5" y="660.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="660.5" y="360.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1380.5" y="360.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="660.5" y="420.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1380.5" y="420.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="720.5" y="0.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="720.5" y="60.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="720.5" y="120.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="720.5" y="480.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="720.5" y="180.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="720.5" y="540.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="720.5" y="240.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="720.5" y="600.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="720.5" y="300.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="720.5" y="660.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="720.5" y="360.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="720.5" y="420.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="780.5" y="0.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="780.5" y="60.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="780.5" y="120.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="780.5" y="480.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="780.5" y="180.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="780.5" y="540.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="780.5" y="240.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="780.5" y="600.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="780.5" y="300.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="780.5" y="660.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="780.5" y="360.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="780.5" y="420.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="840.5" y="60.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="840.5" y="120.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="840.5" y="480.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="840.5" y="240.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="840.5" y="600.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="840.5" y="300.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="840.5" y="660.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="840.5" y="420.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="900.5" y="0.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="900.5" y="60.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="900.5" y="120.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="900.5" y="480.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="900.5" y="180.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="900.5" y="540.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="900.5" y="240.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="900.5" y="600.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="900.5" y="300.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="900.5" y="660.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="900.5" y="360.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="900.5" y="420.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="960.5" y="0.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="960.5" y="120.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="960.5" y="480.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="960.5" y="180.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="960.5" y="540.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="960.5" y="240.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="960.5" y="600.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="960.5" y="360.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="960.5" y="420.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1020.5" y="0.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1020.5" y="60.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1020.5" y="120.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1020.5" y="480.5" width="59" height="59" stroke="#EEEEEE" />
        <rect
          x="0.5"
          y="420.5"
          width="59"
          height="59"
          fill="#EEEEEE"
          stroke="#EEEEEE"
        />
        <rect
          x="60.5"
          y="0.5"
          width="59"
          height="59"
          fill="#EEEEEE"
          stroke="#EEEEEE"
        />
        <rect
          x="60.5"
          y="180.5"
          width="59"
          height="59"
          fill="#EEEEEE"
          stroke="#EEEEEE"
        />
        <rect
          x="60.5"
          y="540.5"
          width="59"
          height="59"
          fill="#EEEEEE"
          stroke="#EEEEEE"
        />
        <rect
          x="120.5"
          y="360.5"
          width="59"
          height="59"
          fill="#EEEEEE"
          stroke="#EEEEEE"
        />
        <rect
          x="180.5"
          y="60.5"
          width="59"
          height="59"
          fill="#EEEEEE"
          stroke="#EEEEEE"
        />
        <rect
          x="180.5"
          y="240.5"
          width="59"
          height="59"
          fill="#EEEEEE"
          stroke="#EEEEEE"
        />
        <rect
          x="180.5"
          y="600.5"
          width="59"
          height="59"
          fill="#EEEEEE"
          stroke="#EEEEEE"
        />
        <rect
          x="300.5"
          y="300.5"
          width="59"
          height="59"
          fill="#EEEEEE"
          stroke="#EEEEEE"
        />
        <rect
          x="300.5"
          y="660.5"
          width="59"
          height="59"
          fill="#EEEEEE"
          stroke="#EEEEEE"
        />
        <rect
          x="360.5"
          y="60.5"
          width="59"
          height="59"
          fill="#EEEEEE"
          stroke="#EEEEEE"
        />
        <rect
          x="1080.5"
          y="60.5"
          width="59"
          height="59"
          fill="#EEEEEE"
          stroke="#EEEEEE"
        />
        <rect
          x="420.5"
          y="180.5"
          width="59"
          height="59"
          fill="#EEEEEE"
          stroke="#EEEEEE"
        />
        <rect
          x="420.5"
          y="540.5"
          width="59"
          height="59"
          fill="#EEEEEE"
          stroke="#EEEEEE"
        />
        <rect
          x="1140.5"
          y="180.5"
          width="59"
          height="59"
          fill="#EEEEEE"
          stroke="#EEEEEE"
        />
        <rect
          x="1140.5"
          y="540.5"
          width="59"
          height="59"
          fill="#EEEEEE"
          stroke="#EEEEEE"
        />
        <rect
          x="420.5"
          y="420.5"
          width="59"
          height="59"
          fill="#EEEEEE"
          stroke="#EEEEEE"
        />
        <rect
          x="1140.5"
          y="420.5"
          width="59"
          height="59"
          fill="#EEEEEE"
          stroke="#EEEEEE"
        />
        <rect
          x="540.5"
          y="0.5"
          width="59"
          height="59"
          fill="#EEEEEE"
          stroke="#EEEEEE"
        />
        <rect
          x="1260.5"
          y="0.5"
          width="59"
          height="59"
          fill="#EEEEEE"
          stroke="#EEEEEE"
        />
        <rect
          x="540.5"
          y="300.5"
          width="59"
          height="59"
          fill="#EEEEEE"
          stroke="#EEEEEE"
        />
        <rect
          x="540.5"
          y="660.5"
          width="59"
          height="59"
          fill="#EEEEEE"
          stroke="#EEEEEE"
        />
        <rect
          x="1260.5"
          y="300.5"
          width="59"
          height="59"
          fill="#EEEEEE"
          stroke="#EEEEEE"
        />
        <rect
          x="1260.5"
          y="660.5"
          width="59"
          height="59"
          fill="#EEEEEE"
          stroke="#EEEEEE"
        />
        <rect
          x="600.5"
          y="120.5"
          width="59"
          height="59"
          fill="#EEEEEE"
          stroke="#EEEEEE"
        />
        <rect
          x="600.5"
          y="480.5"
          width="59"
          height="59"
          fill="#EEEEEE"
          stroke="#EEEEEE"
        />
        <rect
          x="1320.5"
          y="120.5"
          width="59"
          height="59"
          fill="#EEEEEE"
          stroke="#EEEEEE"
        />
        <rect
          x="1320.5"
          y="480.5"
          width="59"
          height="59"
          fill="#EEEEEE"
          stroke="#EEEEEE"
        />
        <rect
          x="600.5"
          y="360.5"
          width="59"
          height="59"
          fill="#EEEEEE"
          stroke="#EEEEEE"
        />
        <rect
          x="1320.5"
          y="360.5"
          width="59"
          height="59"
          fill="#EEEEEE"
          stroke="#EEEEEE"
        />
        <rect
          x="660.5"
          y="240.5"
          width="59"
          height="59"
          fill="#EEEEEE"
          stroke="#EEEEEE"
        />
        <rect
          x="660.5"
          y="600.5"
          width="59"
          height="59"
          fill="#EEEEEE"
          stroke="#EEEEEE"
        />
        <rect
          x="1380.5"
          y="240.5"
          width="59"
          height="59"
          fill="#EEEEEE"
          stroke="#EEEEEE"
        />
        <rect
          x="1380.5"
          y="600.5"
          width="59"
          height="59"
          fill="#EEEEEE"
          stroke="#EEEEEE"
        />
        <rect
          x="840.5"
          y="0.5"
          width="59"
          height="59"
          fill="#EEEEEE"
          stroke="#EEEEEE"
        />
        <rect
          x="840.5"
          y="180.5"
          width="59"
          height="59"
          fill="#EEEEEE"
          stroke="#EEEEEE"
        />
        <rect
          x="840.5"
          y="540.5"
          width="59"
          height="59"
          fill="#EEEEEE"
          stroke="#EEEEEE"
        />
        <rect
          x="840.5"
          y="360.5"
          width="59"
          height="59"
          fill="#EEEEEE"
          stroke="#EEEEEE"
        />
        <rect
          x="960.5"
          y="60.5"
          width="59"
          height="59"
          fill="#EEEEEE"
          stroke="#EEEEEE"
        />
        <rect
          x="960.5"
          y="300.5"
          width="59"
          height="59"
          fill="#EEEEEE"
          stroke="#EEEEEE"
        />
        <rect
          x="960.5"
          y="660.5"
          width="59"
          height="59"
          fill="#EEEEEE"
          stroke="#EEEEEE"
        />
        <rect
          x="1020.5"
          y="180.5"
          width="59"
          height="59"
          fill="#EEEEEE"
          stroke="#EEEEEE"
        />
        <rect
          x="1020.5"
          y="540.5"
          width="59"
          height="59"
          fill="#EEEEEE"
          stroke="#EEEEEE"
        />
        <rect x="1020.5" y="240.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1020.5" y="600.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1020.5" y="300.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1020.5" y="660.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1020.5" y="360.5" width="59" height="59" stroke="#EEEEEE" />
        <rect x="1020.5" y="420.5" width="59" height="59" stroke="#EEEEEE" />
        <rect
          width="1440"
          height="382"
          transform="translate(0 338)"
          fill="url(#paint0_linear_15464_15353)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_15464_15353"
          x1="720"
          y1="382"
          x2="720"
          y2="-1.783e-05"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  )
}
